module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanFallowDeer_f_albino.fdd5eb45.png";